import React from 'react';
import { Box, Skeleton } from '@mui/material';

const CalendarSchedulerSkeleton = () => {
  return (
    <Box
      className="table-scheduler-wrapper calendar-table"
      sx={{
        overflowX: 'auto',
        borderRadius: '4px',
        // border: '1px solid #ddd',
        bgcolor: '#fff',
        margin: '30px 0px',
      }}
    >
      {/* Header Row */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: '40px',
          bgcolor: '#F2F2F2',
          borderBottom: '1px solid #ddd',
        }}
      >
        <Box sx={{ width: '120px', minWidth: '120px', pl: '30px' }}>
          <Skeleton variant="text" width={60} height={22} animation="wave" />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: "space-between", flexGrow: 1, gap: 4, px: 2, overflow: 'hidden' }}>
          {Array.from({ length: 14 }).map((_, i) => (
            <Skeleton key={i} variant="text" width={45} height={20} animation="wave" />
          ))}
        </Box>
      </Box>

      {/* Resource / Table Rows */}
      {Array.from({ length: 6 }).map((_, rowIdx) => {
        return (
          <Box
            key={rowIdx}
            sx={{
              display: 'flex',
              alignItems: 'center',
              minHeight: '80px',
              borderBottom: rowIdx === 5 ? 'none' : '1px solid #ddd',
            }}
          >
            <Box sx={{ width: '120px', minWidth: '120px', pl: '30px' }}>
              <Skeleton variant="text" width={55} height={24} animation="wave" />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, gap: 2, px: 2, overflow: 'hidden' }}>
              {rowIdx % 3 === 0 && (
                <>
                  <Skeleton variant="rectangular" width={140} height={56} animation="wave" sx={{ borderRadius: '5px', ml: 2 }} />
                  <Skeleton variant="rectangular" width={100} height={56} animation="wave" sx={{ borderRadius: '5px', ml: 4 }} />
                </>
              )}
              {rowIdx % 3 === 1 && (
                <>
                  <Skeleton variant="rectangular" width={180} height={56} animation="wave" sx={{ borderRadius: '5px', ml: 12 }} />
                  <Skeleton variant="rectangular" width={120} height={56} animation="wave" sx={{ borderRadius: '5px', ml: 6 }} />
                </>
              )}
              {rowIdx % 3 === 2 && (
                <>
                  <Skeleton variant="rectangular" width={110} height={56} animation="wave" sx={{ borderRadius: '5px', ml: 6 }} />
                  <Skeleton variant="rectangular" width={160} height={56} animation="wave" sx={{ borderRadius: '5px', ml: 8 }} />
                </>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default CalendarSchedulerSkeleton;
